<script lang="ts">
    import { t } from "$lib/i18n/translations";
    import { emotions, type MeowbaltEmotions } from "$lib/types/meowbalt";

    type Props = {
        emotion: MeowbaltEmotions;
        forceLoaded?: boolean;
    };

    const { emotion, forceLoaded }: Props = $props();

    let loaded = $state(false);

    const real = $derived(
        emotion === "random"
            ? emotions[Math.floor(Math.random() * emotions.length)]
            : emotion
    );
</script>

<img
    class="meowbalt {real}"
    class:loaded={loaded || forceLoaded}
    onload={() => (loaded = true)}
    src="/meowbalt/{real}.png"
    height="152"
    alt={$t("general.meowbalt")}
    aria-hidden="true"
/>

<style>
    .meowbalt {
        display: block;
        margin: 0;
        object-fit: cover;
        opacity: 0;
        transition: opacity 0.15s;
    }

    .meowbalt.loaded {
        opacity: 1;
    }
</style>
